// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientQuestionnaire_root__Wvx9q","header":"PatientQuestionnaire_header__1k95m","info":"PatientQuestionnaire_info__1HZvY"};